"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Phone, MapPin } from "lucide-react";
import { useEffect, useState } from "react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [logoVisible, setLogoVisible] = useState(false);
  const [navVisible, setNavVisible] = useState(false);
  useEffect(() => {
    const logoTimer = setTimeout(() => setLogoVisible(true), 100);
    const navTimer = setTimeout(() => setNavVisible(true), 300);
    return () => {
      clearTimeout(logoTimer);
      clearTimeout(navTimer);
    };
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-light-background shadow-soft">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className={`flex items-center gap-3 transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] ${logoVisible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`}>
            <Link to="/HomePage" className="focus-ring rounded-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/smart_buy_appliances_logo.png" alt="Smart Buy Appliances - Raleigh NC" className="h-7" />
            </Link>
            <div className="hidden lg:flex items-center gap-1.5 text-xs text-foreground/70 border-l border-border pl-3">
              <MapPin className="size-3.5" />
              <span>Serving Raleigh-Durham Area</span>
            </div>
          </div>

          <div className={`hidden md:flex items-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${navVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <MenuProvider menu_id="18">
              <HeaderMenuConsumer />
            </MenuProvider>
          </div>

          <div className={`md:hidden transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${navVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <Link to="tel:(919) 703-0041" className="inline-flex items-center gap-2 rounded-md bg-accent text-foreground-accent px-4 py-2 font-semibold hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 focus-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              <Phone className="size-4" />
              <span>Call Now</span>
            </Link>
          </div>
        </div>
      </div>
    </header>;
}